import { DEFAULT_ROUGHNESS, ShapeStyle, StrokeStyle } from '../../consts.js';
import { CanvasElementType, } from '../edgeless-element.js';
export const ShapeElementDefaultProps = {
    type: CanvasElementType.SHAPE,
    xywh: '[0,0,0,0]',
    rotate: 0,
    shapeType: 'rect',
    shapeStyle: ShapeStyle.General,
    radius: 0,
    filled: false,
    fillColor: '#ffffff',
    strokeWidth: 4,
    strokeColor: '#000000',
    strokeStyle: StrokeStyle.Solid,
    roughness: DEFAULT_ROUGHNESS,
};
export var SHAPE_TEXT_FONT_SIZE;
(function (SHAPE_TEXT_FONT_SIZE) {
    SHAPE_TEXT_FONT_SIZE[SHAPE_TEXT_FONT_SIZE["SMALL"] = 12] = "SMALL";
    SHAPE_TEXT_FONT_SIZE[SHAPE_TEXT_FONT_SIZE["MEDIUM"] = 20] = "MEDIUM";
    SHAPE_TEXT_FONT_SIZE[SHAPE_TEXT_FONT_SIZE["LARGE"] = 28] = "LARGE";
    SHAPE_TEXT_FONT_SIZE[SHAPE_TEXT_FONT_SIZE["XLARGE"] = 36] = "XLARGE";
})(SHAPE_TEXT_FONT_SIZE || (SHAPE_TEXT_FONT_SIZE = {}));
export const SHAPE_TEXT_PADDING = 20;
export const FILL_COLORS = [
    '--affine-palette-shape-yellow',
    '--affine-palette-shape-orange',
    '--affine-palette-shape-tangerine',
    '--affine-palette-shape-red',
    '--affine-palette-shape-magenta',
    '--affine-palette-shape-purple',
    '--affine-palette-shape-green',
    '--affine-palette-shape-blue',
    '--affine-palette-shape-navy',
    '--affine-palette-shape-black',
    '--affine-palette-shape-white',
    '--affine-palette-transparent',
];
export const DEFAULT_SHAPE_FILL_COLOR = FILL_COLORS[0];
export const STROKE_COLORS = [
    '--affine-palette-line-yellow',
    '--affine-palette-line-orange',
    '--affine-palette-line-tangerine',
    '--affine-palette-line-red',
    '--affine-palette-line-magenta',
    '--affine-palette-line-purple',
    '--affine-palette-line-green',
    '--affine-palette-line-blue',
    '--affine-palette-line-navy',
    '--affine-palette-line-black',
    '--affine-palette-line-white',
    '--affine-palette-transparent',
];
export const DEFAULT_SHAPE_STROKE_COLOR = STROKE_COLORS[0];
//# sourceMappingURL=consts.js.map